<template>
  <div class="site-page site-page--fluid nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">评论</h1>
      <el-tabs :model-value="activeTab" @tab-change="onTabChange">
        <el-tab-pane label="我评论" name="mine" />
        <el-tab-pane label="评论我" name="received" />
      </el-tabs>

      <div v-loading="loading" class="comment-list">
        <el-empty v-if="!loading && comments.length === 0" :description="emptyText" />
        <div
          v-for="item in comments"
          :key="item.commentId"
          class="comment-card"
        >
          <el-avatar :src="avatarUrl(item.avatar)" :size="40" @click="openProfile(item.uuid)">
            {{ (item.nickName || '?').slice(0, 1) }}
          </el-avatar>
          <div class="comment-card__body">
            <div class="comment-card__meta">
              <span class="comment-card__name" @click="openProfile(item.uuid)">{{ item.nickName || '用户' }}</span>
              <span class="comment-card__time">{{ formatTime(item.createdAt) }}</span>
            </div>
            <p class="comment-card__content">{{ item.content }}</p>
            <p v-if="item.momentContent" class="comment-card__moment">
              原动态{{ item.momentUserNickname ? ` · ${item.momentUserNickname}` : '' }}：{{ item.momentContent }}
            </p>
            <el-button type="primary" link @click="goMoment">查看动态</el-button>
          </div>
        </div>
      </div>

      <el-pagination
        v-if="total > pageSize"
        class="pager"
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        @current-change="onPage"
      />
    </div>
  </div>
</template>

<script>
import { resolveProfilePhotoUrl } from '@/utils/photoUpload'

export default {
  name: 'CommentActivityView',
  data() {
    return {
      loading: false,
      comments: [],
      total: 0,
      page: 1,
      pageSize: 20
    }
  },
  computed: {
    activeTab() {
      return this.$route.query.tab === 'mine' ? 'mine' : 'received'
    },
    emptyText() {
      return this.activeTab === 'mine' ? '还没有发表过评论' : '还没有人评论你的动态'
    }
  },
  watch: {
    activeTab: {
      immediate: true,
      handler() {
        this.page = 1
        this.load()
      }
    }
  },
  methods: {
    onTabChange(tab) {
      if (tab === this.activeTab) return
      this.$router.replace({ path: '/comments', query: { tab } })
    },
    avatarUrl(avatar) {
      return resolveProfilePhotoUrl(avatar, '') || ''
    },
    formatTime(ts) {
      if (!ts) return ''
      const n = Number(ts)
      const date = n > 1e12 ? new Date(n) : new Date(n * 1000)
      if (Number.isNaN(date.getTime())) return ''
      return date.toLocaleString('zh-CN')
    },
    openProfile(uuid) {
      if (uuid) {
        this.$router.push(`/profile/${uuid}`)
      }
    },
    goMoment() {
      this.$router.push('/moment')
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    async load() {
      const token = localStorage.getItem('jwt_token')
      if (!token) return
      this.loading = true
      try {
        const url = this.activeTab === 'mine'
          ? '/api/v1/comment/list/my'
          : '/api/v1/comment/list/received'
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ page: this.page, pageSize: this.pageSize })
        })
        const data = await response.json()
        if (data.code === 200) {
          this.comments = data.data?.comments || []
          this.total = data.data?.total || 0
        } else {
          this.$message.error(data.message || '获取评论失败')
          this.comments = []
          this.total = 0
        }
      } catch (e) {
        console.error(e)
        this.$message.error('获取评论失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.comment-list {
  min-height: 120px;
}
.comment-card {
  display: flex;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid #f0f2f5;
}
.comment-card__body {
  flex: 1;
  min-width: 0;
}
.comment-card__meta {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 4px;
}
.comment-card__name {
  font-weight: 600;
  cursor: pointer;
}
.comment-card__time {
  font-size: 12px;
  color: #909399;
}
.comment-card__content {
  margin: 0 0 8px;
  white-space: pre-wrap;
  word-break: break-word;
}
.comment-card__moment {
  margin: 0 0 6px;
  font-size: 13px;
  color: #909399;
  background: #f7f8fa;
  padding: 8px 10px;
  border-radius: 6px;
}
.pager {
  margin-top: 16px;
  justify-content: center;
}
</style>
